<template>
  <div class="product-terms-card-grid">
    <product-term-card
      v-for="term in mappedTerms"
      :key="term.key"
      :term="term"
      v-bind="$attrs"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { IAvailableTermMapped } from "@/models/providers/products";

export default defineComponent({
  name: "ProductTermCardGrid",
  components: {
    "product-term-card": () =>
      import(
        "@/components/app/global/baskets/basket/productView/productTermCard.vue"
      )
  },
  props: {
    mappedTerms: {
      type: Array as PropType<IAvailableTermMapped[]>,
      default: () => []
    }
  }
});
</script>

<style lang="scss" scoped>
.product-terms-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10rem, auto));
  gap: 0.75rem;
  @include tablet {
    grid-template-columns: repeat(auto-fill, minmax(12rem, auto));
  }
}
</style>
